export default __webpack_public_path__ + "static/media/E512D5C0-D20D-48C4-B51E-DF35EEBEE2822.12b217f2.jpg";